import React from "react";
import { Card, CardContent, Typography, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";

export interface Plan {
  planName: string;
  planAmount: number;
  policyCount: number;
  isActive: boolean;
  activeUser: number;
  requestedUser: string;
  userLimit: Record<string, string>;
}

const SubscriptionCard: React.FC<Plan> = (plan) => {
  const navigate = useNavigate();
  const cardData = [
    { label: "Price", value: `₹${plan.planAmount}` },
    { label: "Policy Count", value: plan.policyCount },
    { label: "Active Users", value: plan.activeUser },
    { label: "Requested Users", value: plan.requestedUser },
  ]
  const user = Object.keys(plan.userLimit)?.map((ele) => {
    return {
      label: ele,
      value: Number(plan.userLimit?.[ele]) > 100000 ? "Unlimited" : plan.userLimit?.[ele] || "N/A"
    };
  })


  return (
    <Grid
      item
      xs={12}
      sm={6}
      md={6}
      lg={4}
      className="flex justify-center"
    >
      <Card className="rounded-2xl cursor-pointer shadow-lg bg-white transition-transform duration-300 ease-in-out hover:scale-105 w-[85%] lg:w-[85%] h-auto max-h-[35vh]">
        <CardContent
          className="p-4 sm:p-5 md:p-6 lg:p-7"
          onClick={() => navigate("/subscription")}
        >
          <Typography
            variant="h6"
            className="text-[#e59411] font-medium mb-2 flex justify-between"
          >
            {plan.planName}
            <span className="relative flex size-2" title={plan.isActive ? "Active" : "Inactive"}>
              <span className={`absolute inline-flex h-full w-full animate-ping rounded-full ${plan.isActive ? "bg-green-400 opacity-75" : "bg-red-400 opacity-75"}`}></span>
              <span className={`relative inline-flex size-2 rounded-full ${plan.isActive ? "bg-green-500" : "bg-red-500"}`}></span>
            </span>
          </Typography>

          {[...cardData, ...user].map((item) => (
            <Typography
              key={item.label}
              className="text-[#027AAE] text-sm font-satoshi font-semibold flex mt-1 justify-between capitalize"
            >
              {item.label}
              <span className="text-black font-[500]">{item.value}</span>
            </Typography>
          ))}
        </CardContent>
      </Card>
    </Grid>
  );
};

export default SubscriptionCard;
